import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { INotification } from './interfaces';

export const getNotificationList = (config?: AxiosRequestConfig) => {
  return instance()
    .get<{ list: INotification[]; totalCount: number }>(`/notification/list`, config)
    .then((response) => response.data);
};

export const readNotifications = (notificationIds: number[]) => {
  return instance()
    .post('/notification/updateView', { notificationIds })
    .then((response) => response.data);
};

export const readAllNotifications = () => {
  return instance()
    .post('/notification/updateViewAll')
    .then((response) => response.data);
};

export const deleteNotifications = (notificationIds: number[]) => {
  return instance()
    .post('/notification/delete', { notificationIds })
    .then((response) => response.data);
};

export const deleteAllNotifications = () => {
  return instance()
    .post('/notification/deleteAll')
    .then((response) => response.data);
};

export const hasNotificationsService = () => {
  return instance()
    .get<{ hasNotView: boolean }>('/notification/hasNotView')
    .then((response) => response.data);
};
